<template>
  <div
    :class="getStyleClass"
  >
    <label
      v-for="(option, index) in options"
      :key="`ScimRadioButtonGroup_${id}_${index}`"
      :class="[
        $style.flexLabel,
        {active: currentValue === option.value},
        {ScimRadioButtonGroup__active: currentValue === option.value}
      ]"
      :for="`ScimRadioButtonGroup_${id}_${index}`"
    >
      <input
        :id="`ScimRadioButtonGroup_${id}_${index}`"
        v-model="currentValue"
        :class="$style.hiddenRadio"
        :name="`ScimRadioButtonGroup_${id}`"
        type="radio"
        :value="option.value"
        @change="handleChange"
      >
      <span>
        {{ option.text }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ScimRadioButtonGroup',

  props: {
    handleOptionChange: {
      type: Function,
      default: () => {},
    },
    options: {
      type: Array,
      require: true,
      default: () => [],
      validate: options => options.every(option => option.text && option.value),
    },
    state: {
      type: [String, Number, Boolean],
      default: '',
    },
    usePrettyToggles: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const defaultOption = this.options.find(option => option.checked)
      || this.options[0];
    return {
      currentValue: this.state || defaultOption.value,
      id: Date.now(),
    };
  },

  computed: {
    getStyleClass() {
      let styleClass = this.$style.radioGroup;
      if (this.usePrettyToggles) styleClass = this.$style.prettyToggleRadioGroup;
      return styleClass;
    },
  },

  watch: {
    state(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentValue = newVal;
      }
    },
  },

  methods: {
    handleChange() {
      this.handleOptionChange(this.currentValue);
    },
  },
};
</script>

<style module>
@value (jcGrey, jcGrey100, jcPrimary) from '~css/brand-colors.css';

.flexLabel {
  align-items: center;
  display: inline-flex;
}

.scimVersion > label {
  font-size: 13px;
}

.radioGroup {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.prettyToggleRadioGroup {
  margin: 0.7rem 0;
}

.prettyToggleRadioGroup label {
  background-color: var(--jcGrey100);
  border: 1px solid var(--jcGrey);
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  padding: 5px 19px;
}

.prettyToggleRadioGroup .hiddenRadio {
  appearance: none;
}

.prettyToggleRadioGroup label:first-child {
  border-left: 1px solid var(--jcGrey);
  border-radius: 4px 0 0 4px;
}

.prettyToggleRadioGroup label:last-child {
  border-radius: 0 4px 4px 0;
}

.prettyToggleRadioGroup .active {
  background-color: var(--jcPrimary);
}
</style>
